// extracted by mini-css-extract-plugin
export default {"consentContainer":"styles_consentContainer__x1s8G","divider":"styles_divider__CqrzK","text":"styles_text__5uL62","sectionTitle":"styles_sectionTitle__8aTgU"};